//import {Recast} from 'recast-detour';

//window.Recast = Recast;// require('./recast.js');


window.Recast = require('recast-detour');
